// 語系切換：假設 URL 路徑第一段為語系碼（例如 /zh-hant/about）。
//
// ── <select> ─────────────────────────────────────────────────────────────
//   <select class="js-lang-selectors" aria-label="語系">
//     <option value="zh-hant">繁中</option>
//     <option value="en">English</option>
//   </select>
//   change 時使用選中項的 value，不需 data-path-prefix。
//
// ── Dropdown（Bootstrap 5）────────────────────────────────────────────────
//   在「容器」上加 .js-lang-selectors（勿加在 select 上以外的同一層混用同一個 handler 的奇怪結構即可），
//   在要切換語系的控制項上加 data-lang="語系碼"（通常為 button.dropdown-item）：
//
//   <div class="dropdown js-lang-selectors">
//     <button class="btn dropdown-toggle" type="button" data-bs-toggle="dropdown">語系</button>
//     <ul class="dropdown-menu dropdown-menu-end">
//       <li><button type="button" class="dropdown-item" data-lang="zh-hant">繁中</button></li>
//       <li><button type="button" class="dropdown-item" data-lang="en">English</button></li>
//     </ul>
//   </div>
//
//   單一按鈕同時作為容器與選項時：
//   <button type="button" class="js-lang-selectors" data-lang="en">English</button>
//
// 新路徑：將 location.pathname 以 '/' split 後把 [1] 代成語系碼，再 join，並接上 .search、.hash；
// 連續斜線會壓成單一 '/'。
//
// 預設：location.assign。在觸發元素上可監聽可取消事件「odin:lang-select」
// （detail: { target, lang, url }），呼叫 preventDefault() 可改為自行導頁。
export default (() => {
  function pathnameWithFirstSegmentReplaced(code) {
    const lang = code != null ? String(code).trim() : ''
    const segments = window.location.pathname.split('/')
    if (segments.length < 2) {
      segments[0] = ''
      segments[1] = lang
    } else {
      segments[1] = lang
    }
    let path = segments.join('/')
    path = path.replace(/\/{2,}/g, '/')
    return path || '/'
  }

  function assignLang(lang, triggerEl) {
    const url =
      pathnameWithFirstSegmentReplaced(lang) +
      window.location.search +
      window.location.hash
    const ev = new CustomEvent('odin:lang-select', {
      cancelable: true,
      bubbles: true,
      detail: { target: triggerEl, lang, url },
    })
    if (!triggerEl.dispatchEvent(ev)) return
    window.location.assign(url)
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-lang-selectors').forEach((root) => {
      if (root.tagName === 'SELECT') {
        root.addEventListener('change', () => {
          assignLang(root.value, root)
        })
        return
      }

      root.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-lang]')
        if (!trigger || !root.contains(trigger)) return
        // 巢狀多層 .js-lang-selectors 時只由「最內層」容器處理，避免重複導頁
        if (trigger.closest('.js-lang-selectors') !== root) return
        e.preventDefault()
        assignLang(trigger.getAttribute('data-lang') || '', trigger)
      })
    })
  })
})()
